import { createAction } from 'redux-actions';
import { makeNotification } from './makeNotification';
export var addNotification = createAction('NOTIFICATIONS.ADD', function (type, params) {
    return makeNotification(type, params);
});
export var removeNotification = createAction('NOTIFICATIONS.REMOVE', function (id) { return id; });
//# sourceMappingURL=actionCreators.js.map